
/* ============================= */
/* VERSION V1.1 - HERO.JSX */
/* ============================= */
import React from "react";
import "../styles/Hero.css";

const Hero = () => {
  return (
    <section className="hero" aria-label="Taxi de la Douce">
      <div className="hero-content">
        <h1 className="hero-brand">TAXI DE LA DOUCE</h1>

        {/* Slogan officiel */}
        <p className="hero-slogan">Votre trajet en toute distinction.</p>

        <div className="hero-buttons">
          <a
            href="tel:+33749424919"
            className="btn btn-primary"
            aria-label="Appeler Taxi de la Douce"
          >
            📞 Appeler
          </a>

          <a
            href="https://wa.me/33749424919"
            className="btn btn-secondary"
            aria-label="WhatsApp Taxi de la Douce"
            target="_blank"
            rel="noopener noreferrer"
          >
            💬 WhatsApp
          </a>

          <a
            href="#reservation"
            className="btn btn-secondary"
            aria-label="Pré-réservation"
          >
            🚖 Pré-réservation
          </a>
        </div>

        {/* SEO discret */}
        <span className="sr-only">
          Taxi Belfort, transferts gare de Belfort, aéroport Bâle-Mulhouse, longue distance, réservation 24h/24.
        </span>
      </div>
    </section>
  );
};

export default Hero;





